module.exports = __webpack_public_path__ + "img/2_5_unit_1.90a1629c.png";